export default {
  SET_USER_INFO(state, users) {
    state.userInfo = { ...users };
  },
};
